import { defineComponent, unref, resolveComponent, ref, watch } from 'vue';import { defineComponent as _defineComponent } from 'vue';
import { unref as _unref, renderSlot as _renderSlot, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, resolveDirective as _resolveDirective, createElementBlock as _createElementBlock, withDirectives as _withDirectives, mergeProps as _mergeProps, createVNode as _createVNode } from "vue";
const _hoisted_1 = {
  class: "my-header"
};
const _hoisted_2 = {
  class: "title"
};
const _hoisted_3 = {
  class: "body-box load-box scroll_bar"
};
const _hoisted_4 = {
  class: "body-box scroll_bar"
};
const _hoisted_5 = {
  class: "footer-box"
};
export default /*#__PURE__*/_defineComponent({
  __name: 'selfDialog',
  props: {
    visible: {
      type: Boolean
    },
    width: null,
    hideClose: {
      type: Boolean
    },
    alignCenter: {
      type: Boolean,
      default: false
    },
    loading: {
      type: Boolean
    },
    closeModal: {
      type: Boolean,
      default: false
    }
  },
  emits: ['onCloseDialog', 'onSelfClose', 'update:visible'],
  setup(__props, {
    emit: emits
  }) {
    const props = __props;
    const visible = ref(false);
    // 监听传递的显示值
    watch(() => props.visible, newVal => {
      visible.value = newVal;
    }, {
      immediate: true
    });
    // 关闭操作
    const onCloseDialog = () => {
      visible.value = false;
      emits('update:visible', visible.value);
      emits('onCloseDialog');
    };
    // 弹框关闭时一定触发的事件
    const onSelfClose = () => {
      // 外层点击可以关闭时
      if (props.closeModal) {
        onCloseDialog();
      } else {
        emits('onSelfClose');
        emits('update:visible', visible.value);
      }
    };
    return (_ctx, _cache) => {
      const _component_el_button = _resolveComponent("el-button");
      const _component_el_dialog = _resolveComponent("el-dialog");
      const _directive_load = _resolveDirective("load");
      return _openBlock(), _createElementBlock("div", null, [_createVNode(_component_el_dialog, _mergeProps({
        "model-value": _unref(visible),
        "show-close": false,
        width: __props.width,
        class: "self-dialog-modal",
        "close-on-click-modal": __props.closeModal,
        "close-on-press-escape": false,
        "align-center": __props.alignCenter
      }, _ctx.$attrs, {
        onClose: onSelfClose
      }), {
        header: _withCtx(() => [_createElementVNode("div", _hoisted_1, [_createElementVNode("div", _hoisted_2, [_renderSlot(_ctx.$slots, "header")]), !__props.hideClose && !__props.loading ? (_openBlock(), _createBlock(_component_el_button, {
          key: 0,
          type: "primary",
          link: "",
          onClick: onCloseDialog
        }, {
          default: _withCtx(() => [_createTextVNode(" 关闭 ")]),
          _: 1
        })) : _createCommentVNode("", true)])]),
        default: _withCtx(() => [_withDirectives((_openBlock(), _createElementBlock("div", _hoisted_3, [_createElementVNode("div", _hoisted_4, [_renderSlot(_ctx.$slots, "content")]), _createElementVNode("div", _hoisted_5, [_renderSlot(_ctx.$slots, "footer")])])), [[_directive_load, __props.loading]])]),
        _: 3
      }, 16, ["model-value", "width", "close-on-click-modal", "align-center"])]);
    };
  }
});